import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Swiper, SwiperSlide } from "swiper/react"

// import Swiper core and required modules
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { mySwiper, swiperSlide } from "./carousel.module.css"
// import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper"
// install Swiper modules
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper"

const Carousel = () => {
  const { images } = useStaticQuery(query)
  const sliders = images.nodes[0].images

  return (
    sliders.length > 0 && (
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className={mySwiper}
      >
        {sliders.map((image, index) => {
          return (
            <SwiperSlide key={index} className={swiperSlide}>
              <GatsbyImage
                key={index}
                image={image.asset.gatsbyImageData}
                alt="A dinosaur"
                placeholder="blurred"
                objectFit="cover"
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    )
  )
}

const query = graphql`
  {
    images: allSanitySlider {
      nodes {
        images {
          asset {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    }
  }
`

export default Carousel
